<template>

    <select class="form-control">
        <slot></slot>
    </select>

</template>

<script>
    export default {
        props: ['options', 'value', 'settings'],
        mounted: function () {
            let vm = this;
            let settingsObject;
            if (typeof this.settings === 'object') {
                settingsObject = {...this.settings, ...{data: this.options}};
            } else {
                settingsObject = {data: this.options};
            }
            $(this.$el)
                .select2(settingsObject)
                .val(this.value)
                .trigger('change')
                .on('change', function () {
                    vm.$emit('input', $(this).val());
                });
        },
        watch: {
            value: function (value) {
                if ([...value].sort().join(',') !== [...$(this.$el).val()].sort().join(',')) {
                    $(this.$el).val(value).trigger('change');
                }
            },
            options: function (options) {
                $(this.$el).select2({data: options});
            }
        },
        destroyed: function () {
            $(this.$el).off().select2('destroy');
        }
    }
</script>
